import React from 'react';
import PropTypes from 'prop-types';
import {
  List,
  ListItemText,
  ListItemIcon,
  ListItemButton,
  Collapse
} from '@mui/material';
import {
  ExpandLess,
  ExpandMore
} from '@mui/icons-material';

import { NestedNavigationItem } from './nestedNavigationItem.jsx';

function NavigationItem({
  item,
  index,
  classes,
  selectedNavigationIndices,
  handleToggleCollapsed,
  handleChangePage
}) {
  const isCollapsed = selectedNavigationIndices.indexOf(index) !== -1;
  return (
    <>
      <ListItemButton onClick={() => handleToggleCollapsed(index)}>
        <ListItemIcon>
          <span className={`${item.icon} ${classes.navigationIconFA}`} />
        </ListItemIcon>
        <ListItemText
          inset
          primary={item.text}
          primaryTypographyProps={{ style: { color: 'white ' } }}
        />
        {isCollapsed ? <ExpandLess /> : <ExpandMore />}
      </ListItemButton>
      <Collapse in={isCollapsed} timeout="auto" unmountOnExit>
        <List dense disablePadding>
          {
            item.navlist.map(ni => (
              <NestedNavigationItem
                key={ni.id}
                nestedItem={ni}
                classes={classes}
                handleChangePage={handleChangePage}
              />
            ))
          }
        </List>
      </Collapse>
    </>
  );
}

NavigationItem.propTypes = {
  item: PropTypes.shape({
    icon: PropTypes.string.isRequired,
    id: PropTypes.string.isRequired,
    navlist: PropTypes.arrayOf(PropTypes.shape({
      icon: PropTypes.string.isRequired,
      id: PropTypes.string.isRequired,
      text: PropTypes.string.isRequired,
      url: PropTypes.string.isRequired
    })).isRequired
  }).isRequired,
  index: PropTypes.number.isRequired,
  classes: PropTypes.shape({
    navigationIconFA: PropTypes.string.isRequired
  }).isRequired,
  selectedNavigationIndices: PropTypes.arrayOf(PropTypes.number).isRequired,
  handleToggleCollapsed: PropTypes.func.isRequired,
  handleChangePage: PropTypes.func.isRequired
};

export { NavigationItem };
